import '../../sass/plugins/team_members.scss';

$(() => {
  const nextArrow = $('#team-members-carousel-next-arrow');
  const prevArrow = $('#team-members-carousel-prev-arrow');

  $(
    '#team-members .team-members-carousel-container .team-members-carousel'
  ).slick({
    slidesToShow: 1,
    dots: true,
    appendDots: $('.dots'),
    nextArrow,
    prevArrow,
    mobileFirst: true,
  });
});
